// Conditions confirmées par le propriétaire le 22 septembre 2026.
export const SERVICE_TERMS = {
  minimum: 30,
  deliveryFee: 15,
  restaurantHours: "11h–4h",
  minimumLabel: "30 € minimum hors livraison",
  deliveryLabel: "Livraison : 15 € fixes",
  restaurantLabel: "Restauration : de 11h à 4h",
  paymentLabel: "Espèces, carte bancaire ou lien de paiement",
  hoursAnswer: "L'épicerie livre 24h/24 et 7j/7. La restauration (pizzas, pâtes et desserts) est disponible de 11h à 4h du matin, y compris à Monaco.",
  minimumAnswer: "Le minimum de commande est de 30 € de produits, hors livraison. Les frais de livraison sont fixes : 15 € dans toute notre zone de Cannes à Monaco, y compris Monaco. Une commande de 30 € revient donc à 45 € livraison comprise.",
  paymentAnswer: "Nous acceptons les espèces et la carte bancaire à la livraison, ainsi que le paiement par lien sécurisé après confirmation de la commande. Ces trois moyens de paiement sont disponibles dans toute notre zone, y compris à Monaco.",
};